import { CostType, ProviderType } from "@/services/cloudchipr.api";

export const costTypes: Record<
  CostType,
  { label: string; providers: ProviderType[] }
> = {
  unblended: {
    label: "Unblended/Actual",
    providers: ["aws", "azure"],
  },
  amortized: {
    label: "Amortized",
    providers: ["aws", "azure"],
  },
  net_unblended: {
    label: "Net Unblended",
    providers: ["aws"],
  },
  net_amortized: {
    label: "Net Amortized",
    providers: ["aws"],
  },
  blended: {
    label: "Blended",
    providers: ["aws"],
  },
};

export const getTitleByCostTypeAndProvider = (
  label: string,
  value: CostType,
  provider?: ProviderType,
) => {
  if (!!provider && value === "unblended") {
    return provider === "aws" ? "Unblended" : "Actual";
  }

  return label;
};
